<template>
    <v-col cols="12" class="ma-1">
        <v-card>
            <v-card-text class="pa-6">
                This is placeholder content for an accounts hub page, which will link to all relevant accounts pages from one place
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    /**
     * Display buttons linking through to accounts reports
     */
    export default {
        props:[],

        data: function() {
            return {
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){},

        methods: {},

        computed: {}
    }
</script>
